
export default {
    name: 'MeatLayout',
}
